<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Service Pricing Limits
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <nb-card>
    <div class="col-md-12">
      <mat-checkbox class="col-md-2 pull-right" [(ngModel)]="useLimit" (change)="updateServicePriceUseLimit()">Use Limit</mat-checkbox>
    </div>
    <div class="col-md-12 p-1">
      <div class="data-table-event-file mt-4">
        <table id="accordion" class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Service</th>
              <th scope="col">Sub Service</th>
              <th scope="col">Limit</th>
              <th scope="col">Edit</th>
              <th scope="col">Remove</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let servicePrice of servicePriceLimit">
              <td>
                <div *ngIf="servicePrice.limitRecordKey != currentRecordKey">
                  {{servicePrice.serviceName}}
                </div>
                <div *ngIf="servicePrice.limitRecordKey == currentRecordKey">
                  <mat-form-field>
                    <mat-label>Service</mat-label>
                    <select matNativeControl (change)="getSubServices(editService)" [(ngModel)]="editService">
                      <option *ngFor="let service of serviceList" value="{{service.VendorServiceTypeID}}">
                        {{service.VendorServiceTypeName}}
                      </option>
                    </select>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div *ngIf="servicePrice.limitRecordKey != currentRecordKey">
                  {{servicePrice.subServiceName}}
                </div>
                <div *ngIf="servicePrice.limitRecordKey == currentRecordKey">
                  <mat-form-field>
                    <mat-label>SubService</mat-label>
                    <select matNativeControl [(ngModel)]="editSubService">
                      <option *ngFor="let subService of subServiceList"
                        value="{{subService.VendorServiceToSubServiceMappingID}}">
                        {{subService.VendorSubServiceTypeName}}
                      </option>
                    </select>
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div *ngIf="servicePrice.limitRecordKey != currentRecordKey">
                  ${{servicePrice.priceLimit}}
                </div>
                <div *ngIf="servicePrice.limitRecordKey == currentRecordKey">
                  <mat-form-field>
                    <mat-label>Limit</mat-label>
                    <input type="text" class="w-100" matInput [(ngModel)]="editLimit">
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div *ngIf="servicePrice.limitRecordKey != currentRecordKey">
                  <span title="Edit" (click)="editServicePriceLimit(servicePrice)">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </span>
                </div>
                <div *ngIf="servicePrice.limitRecordKey == currentRecordKey">
                  <span class="links">
                    <a (click)="addServicePriceLimit()">Save</a><br>
                    <a (click)="cancel()">Cancel</a>
                  </span>
                </div>
              </td>
              <td scope="col"><span (click)="deleteServicePriceLimit(servicePrice.limitRecordKey)" title="Remove"><i
                    class="fa fa-trash-o" aria-hidden="true"></i></span></td>
            </tr>
            <tr *ngIf="serviceAdd">
              <td>
                <mat-form-field>
                  <select matNativeControl (change)="getSubServices(service)" [(ngModel)]="service">
                    <option *ngFor="let service of serviceList" value="{{service.VendorServiceTypeID}}">
                      {{service.VendorServiceTypeName}}
                    </option>
                  </select>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <select matNativeControl [(ngModel)]="subService">
                    <option *ngFor="let subService of subServiceList"
                      value="{{subService.VendorServiceToSubServiceMappingID}}">
                      {{subService.VendorSubServiceTypeName}}
                    </option>
                  </select>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input type="text" matInput placeholder="Limit" [(ngModel)]="priceLimit" required>
                </mat-form-field>
              </td>
              <td class="links">
                <a (click)="addServicePriceLimit()">Save</a><br>
                <a (click)='serviceAdd=false'>Cancel</a>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-12">
      <button (click)="servicePricingAdd()" class="btn btn-xs btn-semi-round btn-demo bgBlue pull-right mb-2"> Add
      </button>
    </div>
  </nb-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>